import maplibregl, { type Map } from 'maplibre-gl';
import { Protocol } from 'pmtiles';

const MONTEMEZZO_CENTER: [number, number] = [9.388, 46.155];
const MONTEMEZZO_BOUNDS: [[number, number], [number, number]] = [
  [9.255, 46.030],
  [9.520, 46.280],
];

const STYLE_URL = '/styles/tivano-style.json';

export function initMap(containerId: string): Map {
  const protocol = new Protocol();
  maplibregl.addProtocol('pmtiles', protocol.tile);

  const map = new maplibregl.Map({
    container: containerId,
    style: STYLE_URL,
    center: MONTEMEZZO_CENTER,
    zoom: 13,
    maxBounds: MONTEMEZZO_BOUNDS,
    attributionControl: { compact: true },
  });

  map.on('styleimagemissing', (e) => {
    if (!map.hasImage(e.id)) {
      map.addImage(e.id, { width: 1, height: 1, data: new Uint8Array(4) });
    }
  });

  map.addControl(new maplibregl.NavigationControl(), 'top-right');
  map.addControl(new maplibregl.ScaleControl({ unit: 'metric' }), 'bottom-left');

  return map;
}
